import CreateAttributeList, { componentAttributeTypes} from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, {  setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetNodeComponenentAttributeBinding, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { BusienssControlNames, GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";

import { defaultDropList } from "../Data/WBComponentDefaults";
import WebDesigner from "../WebDesigner";

export default class ProductDetails extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.productDetails;
        this.displayName = "ProductDetails";
        this.dropList = defaultDropList;
        this.editList = [ ...CreateAttributeList(true, true, true, true, false)];
        this.primaryEditAttributes = [];
        this.resizeType = ResizeableType.All;
        this.icon =<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"/></svg>
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }


    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {

        const atts = GetNodeDomAttributes("v-product-details max-100 ", component, screenSize, isEditor);

        if(!isEditor){
            return  <BusinessPlaceHolder node={component} dataKey={BusienssControlNames.productDetails} layout={"0"} classNames={atts.className} />
        }


        return <div {...atts}  {...GetNodeComponenentAttributeBinding(component,isEditor)}>
            <GenericBusinessControl userContext={siteData} layout={""} dataKey={BusienssControlNames.productDetails} />
        </div>
    }
}
